
import MoonLoader from 'react-spinners/MoonLoader';

export const AuthLoader = () => {
  return <MoonLoader color='#cc6633' css={{ display: 'block' }} size={30} />;
};
